import { render, staticRenderFns } from "./ztomindex_A.vue?vue&type=template&id=68c13ffb&scoped=true&"
import script from "./ztomindex_A.vue?vue&type=script&lang=js&"
export * from "./ztomindex_A.vue?vue&type=script&lang=js&"
import style0 from "./ztomindex_A.vue?vue&type=style&index=0&id=68c13ffb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c13ffb",
  null
  
)

export default component.exports